(function () {
  const PILLOW_VARIANT_ID = '49114075431155';
  const PILLOW_NAME = 'Fiber Pillow (Buy 1Take 1)';
  const PILLOW_PRICE = '₱1';

  // Collection IDs to watch
  const MATTRESS_COLLECTION = 'bundle-mattress';
  const BEDFRAME_COLLECTION = 'bedframes';

  // Product handles from those collections - update these with actual handles
  // We'll detect by checking cart against known variant IDs per collection
  let pillowInCart = false;
  let checking = false;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addPillow() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: PILLOW_VARIANT_ID, quantity: 1 })
    });
    pillowInCart = true;
    refreshCart();
    showMessage(true);
  }

  async function removePillow() {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: PILLOW_VARIANT_ID, quantity: 0 })
    });
    pillowInCart = false;
    refreshCart();
    showMessage(false);
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // Also trigger Normcore's cart update if available
    document.dispatchEvent(new CustomEvent('theme:cart:update'));
  }

  function showMessage(show) {
    let msg = document.getElementById('bundle-pillow-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.id = 'bundle-pillow-msg';
      msg.style.cssText = [
        'position:fixed',
        'bottom:120px',
        'left:50%',
        'transform:translateX(-50%)',
        'z-index:9999',
        'margin:0',
        'padding:12px 20px',
        'background:#fff8e1',
        'border:1px solid #f9a825',
        'border-radius:8px',
        'font-size:14px',
        'color:#5d4037',
        'display:none',
        'text-align:center',
        'box-shadow:0 4px 12px rgba(0,0,0,0.15)',
        'white-space:normal',
        'max-width:90vw',
        'width:max-content',
        'max-width:320px'
      ].join(';');
      document.body.appendChild(msg);
    }
    if (show) {
      msg.innerHTML = `🎁 <strong>${PILLOW_NAME}</strong> at <strong>${PILLOW_PRICE}</strong> added to your bundle!`;
      msg.style.display = 'block';
    } else {
      msg.style.display = 'none';
    }
  }

  async function checkCart() {
    if (checking) return;
    checking = true;

    try {
      const cart = await getCart();
      const items = cart.items;

      const hasPillow = items.some(i => String(i.variant_id) === PILLOW_VARIANT_ID);
      const hasMattress = items.some(i =>
        i.product_type?.toLowerCase().includes('mattress') ||
        i.collections?.some(c => c.handle === MATTRESS_COLLECTION)
      );
      const hasBedframe = items.some(i =>
        i.product_type?.toLowerCase().includes('bed frame') ||
        i.product_type?.toLowerCase().includes('bedframe') ||
        i.collections?.some(c => c.handle === BEDFRAME_COLLECTION)
      );

      pillowInCart = hasPillow;

      if (hasMattress && hasBedframe && !hasPillow) {
        await addPillow();
      } else if ((!hasMattress || !hasBedframe) && hasPillow) {
        await removePillow();
      }
    } catch (e) {
      console.error('[Bundle Pillow]', e);
    }

    checking = false;
  }

  function init() {
    // Watch for cart changes triggered by bundle add button
    const bundleBtn = document.querySelector('.js-bundle-button');
    if (bundleBtn) {
      bundleBtn.addEventListener('click', () => {
        setTimeout(checkCart, 1500);
      });
    }

    // Also watch for any cart update events
    document.addEventListener('cart:refresh', () => setTimeout(checkCart, 500));
    document.addEventListener('theme:cart:update', () => setTimeout(checkCart, 500));

    // Watch for fetch requests (intercept cart/add.js calls)
    const origFetch = window.fetch;
    window.fetch = async function (...args) {
      const result = await origFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        setTimeout(checkCart, 800);
      }
      return result;
    };

    // Initial check
    checkCart();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
